import { setupCookiebot } from '@xerius/codey-cookiebot-vue2';
import { useGtm } from '@gtm-support/vue2-gtm';
import appInsights from '@/application-insights';
import getRouteWindowTitle from './router/get-route-window-title';

/**
 *
 * @param {string} lang
 * @param {import('node_modules/vue-router/types/index').Route} toRoute
 */

function initialize(lang, toRoute) {
  if (!window.Cookiebot) {
    setupCookiebot({
      cbid: '33655448-1393-4b43-8126-e8b9cd543ac6', // Xerius domain group id
      language: lang,
      onMarketingAccept() {
        useGtm()?.enable();
      },
      onStatisticsAccept() {
        const ai = appInsights.getInstance();
        ai?.loadAppInsights();
        appInsights.trackRoutePageView(toRoute, getRouteWindowTitle(toRoute));
      }
    });
  }
}

export default {
  initialize
};
